<script setup>
import {ref, onMounted} from 'vue';

const hide = ref(false);

const props = defineProps({
    theme: Object,
    main: Boolean,
})

onMounted(() => {
    setTimeout(() => { hide.value = true; }, 2800);
});
</script>

<template>
    <div
        class="fixed backdrop-blur-xl flex flex-col items-center justify-center w-screen h-screen z-50 top-0 transition-all duration-1000 ease-in-out"
        :class="[
            { 'scale-110 opacity-0 pointer-events-none': hide },
            main ? 'bg-[#F8F8F8] dark:bg-[#101827]' : `bg-${theme?.color}-900/50`
        ]"
    >
        <svg viewBox="0 0 364 422" class="w-[200px]" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id="ll-shimmer" x1="-350" y1="-350" x2="50" y2="50" gradientUnits="userSpaceOnUse">
                    <stop offset="0%"   stop-color="#003cff" />
                    <stop offset="38%"  stop-color="#003cff" />
                    <stop offset="50%"  stop-color="#93b4ff" />
                    <stop offset="62%"  stop-color="#003cff" />
                    <stop offset="100%" stop-color="#003cff" />
                    <animate attributeName="x1" from="-350" to="350" begin="0.65s" dur="1.6s" fill="freeze" />
                    <animate attributeName="y1" from="-350" to="350" begin="0.65s" dur="1.6s" fill="freeze" />
                    <animate attributeName="x2" from="50"   to="750" begin="0.65s" dur="1.6s" fill="freeze" />
                    <animate attributeName="y2" from="50"   to="750" begin="0.65s" dur="1.6s" fill="freeze" />
                </linearGradient>
            </defs>
            <path d="M25.639,218.34l0,-21.343c76.237,0 138.132,-61.895 138.132,-138.132l21.517,0c10.337,1.241 18.563,9.389 19.923,19.689c-0.865,7.964 -2.248,15.773 -4.116,23.393c-15.958,65.113 -67.258,116.414 -132.371,132.372c-7.357,1.803 -14.889,3.155 -22.567,4.025l-0.127,-0c-10.63,-1.071 -19.122,-9.433 -20.391,-20.004Z" fill="url(#ll-shimmer)" class="ll-pa"/>
            <path d="M163.107,327.902c15.959,-65.111 67.259,-116.41 132.371,-132.368c7.509,-1.84 15.203,-3.211 23.046,-4.078c10.464,1.218 18.782,9.513 20.037,19.966l0,21.435c-76.237,0 -138.132,61.895 -138.132,138.132l-21.17,0c-10.571,-1.269 -18.934,-9.761 -20.004,-20.391l-0,-1.604c0.872,-7.168 2.164,-14.208 3.852,-21.093Z" fill="url(#ll-shimmer)" class="ll-pb"/>
        </svg>
    </div>
</template>

<style scoped>
.ll-pa {
    transform-box: fill-box;
    transform-origin: center;
    animation: ll-in-a 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0s both;
}
.ll-pb {
    transform-box: fill-box;
    transform-origin: center;
    animation: ll-in-b 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.08s both;
}

@keyframes ll-in-a {
    from { transform: translate(-140px, -110px); opacity: 0; }
    to   { transform: translate(0, 0);           opacity: 1; }
}
@keyframes ll-in-b {
    from { transform: translate(140px, 110px); opacity: 0; }
    to   { transform: translate(0, 0);         opacity: 1; }
}
</style>
